import React from 'react';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IConfirmWidgetComponentProps } from './ConfirmWidgetFormComponent';
import { ConfirmWidgetLayoutComponent } from './components/ConfirmWidgetLayoutComponent';

/**
 * Componente che gestisce l'anteprima di configurazione di un widget di tipo
 * `Confirm`.
 */
export function ConfirmWidgetPreviewComponent(
  props: IConfirmWidgetComponentProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return <ConfirmWidgetLayoutComponent options={options} {...props} />;
}
